// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenshot-app-parent {
    width: 448px;
    padding: 8px;
    padding-top: 3px;
}

.screenshot-filename-text {
    font-size: 12px;
}

.screenshot-save-button {
    text-align: center;
    padding-top: 8px;
}

.screenshot-name-input .ant-input{
    font-size: 12px;
    background-color: var(--main-bg-color);
    color: var(--theme-text-color);
}

.screenshot-name-input .ant-input:hover {
    border: 2px;
    border-color: var(--theme-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/screenshot.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gDAAgD;AACpD","sourcesContent":[".screenshot-app-parent {\n    width: 448px;\n    padding: 8px;\n    padding-top: 3px;\n}\n\n.screenshot-filename-text {\n    font-size: 12px;\n}\n\n.screenshot-save-button {\n    text-align: center;\n    padding-top: 8px;\n}\n\n.screenshot-name-input .ant-input{\n    font-size: 12px;\n    background-color: var(--main-bg-color);\n    color: var(--theme-text-color);\n}\n\n.screenshot-name-input .ant-input:hover {\n    border: 2px;\n    border-color: var(--theme-text-color) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
